export default {
  ["count"](state) {
    state.counter = state.counter + 1;
  },

  ["fetchEndpoint"](state, endpoint) {
    state.fetchEndpoint = endpoint;
  },
  ["sendEndpoint"](state, endpoint) {
    state.sendEndpoint = endpoint;
  },
  ["sendMethod"](state, method) {
    state.method = method;
  },
  ["fetching"](state, isFetching) {
    state.fetching = isFetching;
  },
  ["sending"](state, isSending) {
    state.sending = isSending;
  },
  ["valid"](state, valid) {
    state.valid = valid;
  },
  ["validating"](state, validating) {
    state.validating = validating;
  },
  ["addValidation"](state) {
    state.validations++;
  },
  ["addError"](state) {
    state.errors++;
  },
  ["resetValidations"](state) {
    state.validations = 0;
    state.errors = 0;
  },
  ["fixedSize"](state, size) {
    state.fixedSize = size;
  },

  ["adapter_in"](state, adapter) {
    state.adapter.in = adapter;
  },
  ["adapter_out"](state, adapter) {
    state.adapter.out = adapter;
  },
  ["adapter_out_header"](state, header) {
    state.adapter.out_header = header;
  },
  ["adapter_out_option"](state, option) {
    state.adapter.out_options[option.key] = option.value;
  },

  ["add"](state, item) {
    state.data.push(item);
  },
  ["addKeyValue"](state, item) {
    state.data[item.key] = item.value;
  },
  // Remove a segment of data by its ID
  ["remove"](state, id) {
    var deleted = false;
    for (var i = 0; !deleted && i < state.data.length; i++) {
      if (state.data[i].id === id) {
        state.referenceDistance++;
        // Enable undo for this operation
        state.redo = [];
        state.undo.push(Array.from(state.data));
        // Splice the data for that element
        state.data.splice(i, 1);
        // Stop iterating
        deleted = true;
      }
    }
  },
  // Action performed when a segment of data is updated.
  ["update"](state, data) {
    state.referenceDistance++;
    state.redo = [];
    state.undo.push(Array.from(state.data));
    var updated = false;
    for (var i = 0; !updated && i < state.data.length; i++) {
      if (state.data[i].id === data.id) {
        state.data[i] = JSON.parse(JSON.stringify(data));
        updated = true;
      }
    }
  },
  // Push a state in the history
  ["push"](state, data) {
    state.referenceDistance++;
    state.redo = [];
    state.undo.push(Array.from(state.data));
    state.data = Array.from(data);
  },
  ["undo"](state) {
    state.referenceDistance--;
    state.redo.push(Array.from(state.data));
    state.data = Array.from(state.undo.pop());
  },
  ["redo"](state) {
    state.referenceDistance++;
    state.undo.push(Array.from(state.data));
    state.data = Array.from(state.redo.pop());
  },
  // Update the data reference to the current data
  ["updateReference"](state) {
    state.referenceDistance = 0;
  },
  // Always call this before destroying the main component
  ["clear"](state) {
    state.data = [];
    state.referenceDistance = 0;
    state.counter = 0;
    state.undo = [];
    state.redo = [];
    state.fetchEndpoint = "";
    state.sendEndpoint = "";
    state.method = "";
    state.fetching = true;
    state.sending = false;
    state.valid = true;
    state.validating = false;
    state.validations = 0;
    state.errors = 0;
    state.fixedSize = null;
    state.adapter = {
      in: null,
      out: null,
      out_header: "",
      out_options: {}
    };
  },
  // Only clear the data
  ["clearData"](state) {
    state.data = [];
    state.referenceDistance = 0;
    state.counter = 0;
    state.undo = [];
    state.redo = [];
    state.validations = 0;
    state.errors = 0;
  }
};
